import styled from 'styled-components'

export const InfosWrap = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  margin-top: 10px;
  gap: 20px;

  button {
    font-size: 15px;
  }
`

export const ModalDivInput = styled.div`
  display: grid;
  flex: 1;
  grid-template-rows: repeat(5, 50px);
  gap: 7px;
  margin-top: 2vh;
`
export const ContentModal = styled.div`
  -webkit-box-shadow: 0 0 40px rgb(8 21 66 / 15%);
  box-shadow: 0 0 40px rgb(8 21 66 / 15%);
`
